module.exports = __webpack_public_path__ + "app/modals/export-data-modal.view.html";